import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import { IconButton, Button } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import TrainIcon from '@material-ui/icons/Train';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Chip from '@material-ui/core/Chip';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import ModalQR from '../../components/ModalQr';
import CropFreeIcon from '@material-ui/icons/CropFree';

import DuplicarViaje from '../ReservaFrom/DuplicarViaje';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 5,
  },
  avatarTren: {
    backgroundColor: '#01579b',
  },
  avatarColectivo: {
    backgroundColor: '#00b0ff',
  },
  buttons: {
    justifyContent: 'right',
  },
  als: {
    color: 'red',
  },
}));

export default function RecipeReviewCard({
  reserva,
  modoEdicion = false,
  btnDuplicar = false,
  onCancelar,
  onCancelarReserva,
}) {
  const classes = useStyles();

  const [openQR, setOpenQR] = useState(false);
  const [openDuplicar, setOpenDuplicar] = useState(false);

  const handleClickOpenQR = () => {
    setOpenQR(true);
  };

  const handleDuplicar = () => {
    setOpenDuplicar(true);
  };

  return (
    <>
      <ModalQR open={openQR} setOpen={setOpenQR} autorizacion={reserva}></ModalQR>
      {btnDuplicar && (
        <DuplicarViaje
          open={openDuplicar}
          setOpen={setOpenDuplicar}
          autorizacion={reserva}
        />
      )}
      <Card className={classes.root} id=''>
        <CardHeader
          avatar={
            <Avatar
              aria-label='recipe'
              className={
                reserva.servicio.tipo.id === 1
                  ? classes.avatarTren
                  : classes.avatarColectivo
              }
            >
              {reserva.servicio.tipo.id === 1 ? <TrainIcon /> : <AirportShuttleIcon />}
            </Avatar>
          }
          title={
            reserva.servicio.tipo.nombre.toUpperCase() + ' ' + reserva.servicio.numero
          }
          subheader={`${moment(reserva.servicio.desde.fecha).format('DD/MM/YYYY')} - ${
            reserva.cantidad
          } ${reserva.cantidad === 1 ? 'Pasajero' : 'Pasajeros'}`}
          action={
            btnDuplicar && (
              <IconButton
                aria-label='copiar'
                color='primary'
                onClick={() => handleDuplicar()}
              >
                <FileCopyIcon />
              </IconButton>
            )
          }
        />

        <CardContent>
          <List component='nav' aria-label='main mailbox folders'>
            <ListItem>
              <ListItemIcon>
                <ArrowForwardIosIcon />
              </ListItemIcon>
              <ListItemText primary={reserva.servicio.desde.nombre.toUpperCase()} />
              <ListItemSecondaryAction>
                <IconButton edge='end' aria-label='comments'>
                  <Chip
                    size='small'
                    label={moment(reserva.servicio.desde.fecha).format('HH:mm')}
                  ></Chip>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <ArrowForwardIosIcon />
              </ListItemIcon>
              <ListItemText primary={reserva.servicio.hasta.nombre.toUpperCase()} />
              <ListItemSecondaryAction>
                <IconButton edge='end' aria-label='comments'>
                  <Chip
                    size='small'
                    label={moment(reserva.servicio.hasta.fecha).format('HH:mm')}
                  ></Chip>
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          </List>
        </CardContent>
        <CardActions disableSpacing className={classes.buttons}>
          {modoEdicion ? (
            <>
              <IconButton aria-label='eliminar' onClick={() => onCancelar(reserva)}>
                <DeleteIcon />
              </IconButton>
            </>
          ) : (
            <>
              {reserva.estado.id === 1 ? (
                <>
                  <Button
                    size='small'
                    color='primary'
                    onClick={() => handleClickOpenQR()}
                    disabled={reserva.estado.id === 2}
                    startIcon={<CropFreeIcon />}
                  >
                    Ver QR
                  </Button>

                  <Button
                    size='small'
                    color='primary'
                    onClick={() => onCancelarReserva(reserva)}
                    startIcon={<DeleteIcon />}
                  >
                    Cancelar
                  </Button>
                </>
              ) : null}
              {reserva.estado.id === 2 ? (
                <>
                  <Button size='small' color='primary' disabled='true'>
                    Cancelado
                  </Button>
                </>
              ) : null}

              {reserva.estado.id === 3 ? (
                <>
                  <Button size='small' color='primary' disabled='true'>
                    Confirmado
                  </Button>
                </>
              ) : null}
            </>
          )}
        </CardActions>
      </Card>
    </>
  );
}
